import { useEffect, useState } from 'react';
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useCommonItems } from "../../../../../../../contexts/CommonItensProvider";
import { carregaConfigsEquipamento, manipulaEquipamento } from "../../../configs/functions";
import { hasAgrupadoPor, normalizeMotoresFromBackend } from "../config/functions";
import {ThirdStepMachineForm} from "../ThirdStep";

export function RestockingMachineDialog({ open, onClose, maquina }) {
    const { exibirAlerta, exibirDialog, handleCloseDialog } = useCommonItems();

    const [motores, setMotores] = useState([]);

    const qtdMotores = maquina?.qtd_motores ?? motores.length;

    const loadConfigsEquipamento = async () => {
        if (!maquina?.id) return;

        exibirDialog('Carregando configurações da máquina...');

        try {
            const response = await carregaConfigsEquipamento({ id_equipamento: maquina.id });
            const data = normalizeMotoresFromBackend(response?.data?.data ?? []);
            setMotores(data);
        } catch (error) {
            exibirAlerta('Erro ao carregar as configurações da máquina', '', 'error');
        } finally {
            handleCloseDialog();
        }
    };

    useEffect(() => {
        if (open) {
            loadConfigsEquipamento();
        } else {
            setMotores([]);
        }
    }, [open, maquina?.id]);

    const handleSave = async () => {
        const semVariacao = motores.find(m => !m.id_produto && m.mustSelectChild);
        if (semVariacao) {
            exibirAlerta('Ops', 'Selecione a variação do produto para o motor ' + semVariacao.numero_motor, 'error');
            return;
        }

        const configs = motores
            .map((motor) => {
                const { id_produto_pai, mustSelectChild, ...rest } = motor;

                const isChild = hasAgrupadoPor(motor);

                return {
                    ...rest,
                    id: motor.id ?? null,
                    numero_motor: Number(motor.numero_motor),
                    agrupado_por: isChild ? Number(motor.agrupado_por) : null,
                    id_produto: isChild ? null : motor.id_produto ?? null,
                    qtd_produto: isChild ? null : motor.qtd_produto ?? 0,
                    capacidade: motor.capacidade ?? null,
                    is_dirty: !!motor.is_dirty,
                };
            })
            .sort((a, b) => {
                const aChild = a.agrupado_por ? 1 : 0;
                const bChild = b.agrupado_por ? 1 : 0;
                return aChild - bChild;
            });

        exibirDialog('Salvando. Aguarde...');
        try {
            const res = await manipulaEquipamento(
                {
                    id: maquina.id,
                    tipo: 'maquina',
                    qtd_motores: maquina.qtd_motores ?? motores.length,
                    configsEquipamento: configs,
                },
                true
            );
            exibirAlerta('Sucesso', res.data.message, 'success');
            onClose();
        } catch (error) {
            console.log('ERRO:', error.response?.data);
            exibirAlerta('Erro', error.response?.data?.error ?? error.response?.data?.message ?? 'Erro ao salvar', 'error');
        } finally {
            handleCloseDialog();
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Reabastecimento — {maquina?.nome}
                <IconButton onClick={onClose}><CloseIcon /></IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <ThirdStepMachineForm
                    equipamento={maquina}
                    values={{ id_empresa: maquina?.empresa?.id ?? maquina?.id_empresa }}
                    motores={motores}
                    setMotores={setMotores}
                    qtdMotores={qtdMotores}
                    restockingMode
                />
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" onClick={onClose}>Cancelar</Button>
                <Button variant="contained" onClick={handleSave}>Salvar</Button>
            </DialogActions>
        </Dialog>
    );
}